Postlogin = (function (postlogin) {
    postlogin.GuardianSummary = {};
    const self = postlogin.GuardianSummary;

    let currentData = null;

    self.init = function () {
        const $btn = $('#generate-guardian-summary');
        const $modal = $('#guardian-summary-modal');
        if (!$btn.length || !$modal.length) return;

        const $content = $('#guardian-summary-content');
        const $loading = $('#guardian-summary-loading');
        const $actions = $('#guardian-summary-actions');
        const $localeToggle = $('#guardian-summary-locale');
        const $copyBtn = $('#guardian-summary-copy');

        $btn.on('click', function () {
            $modal.modal('show');
            fetchSummary('en');
        });

        $modal.on('hidden.bs.modal', function () {
            $content.empty();
            $actions.hide();
            $localeToggle.val('en');
            currentData = null;
        });

        $localeToggle.on('change', function () {
            const locale = $(this).val();
            if (currentData && currentData[locale]) {
                renderSummary(currentData[locale], locale);
            } else {
                fetchSummary(locale);
            }
        });

        $copyBtn.on('click', function () {
            const text = $content.text();
            const resetLabel = function () {
                setTimeout(function () { $copyBtn.text('Copy to Clipboard'); }, 2000);
            };

            // navigator.clipboard is undefined on http:// origins and
            // some embedded contexts. Fall back to the legacy
            // execCommand path so teachers on non-HTTPS dev or
            // iframe-embedded pages aren't left wondering why the
            // button did nothing.
            if (navigator.clipboard) {
                navigator.clipboard.writeText(text).then(function () {
                    $copyBtn.text('Copied!');
                    resetLabel();
                }).catch(function () {
                    $copyBtn.text('Copy failed');
                    resetLabel();
                });
                return;
            }

            try {
                const ta = document.createElement('textarea');
                ta.value = text;
                ta.style.position = 'fixed';
                ta.style.opacity = '0';
                document.body.appendChild(ta);
                ta.focus();
                ta.select();
                document.execCommand('copy');
                document.body.removeChild(ta);
                $copyBtn.text('Copied!');
            } catch (e) {
                $copyBtn.text('Copy failed');
            }
            resetLabel();
        });

        function fetchSummary(locale) {
            $loading.show();
            $content.empty();
            $actions.hide();

            const userId = $btn.attr('data-user-id');
            const url = '/api/users/' + encodeURIComponent(userId) + '/guardian-summary/?locale=' + encodeURIComponent(locale);

            $.ajax({
                url: url,
                type: 'GET',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                dataType: 'json',
            }).done(function (resp) {
                if (resp && resp.data) {
                    if (!currentData) currentData = {};
                    currentData[resp.data.locale] = resp.data;
                    renderSummary(resp.data, resp.data.locale);
                } else if (resp && resp.message) {
                    renderError(resp.message);
                } else {
                    renderError('An error occurred. Please try again.');
                }
            }).fail(function (xhr) {
                if (xhr.status === 403) {
                    renderError('You do not have permission to generate guardian summaries.');
                } else if (xhr.status === 404) {
                    renderError('Student not found.');
                } else {
                    renderError('An error occurred. Please try again.');
                }
            }).always(function () {
                $loading.hide();
            });
        }

        // Use DOM APIs instead of innerHTML so Bedrock output and
        // server messages cannot inject script tags or HTML. Model
        // output flows to the user and must be treated as untrusted
        // even though it originates from our own backend.
        function renderSummary(data, locale) {
            $content.empty();

            const paragraphs = (data.summary || '').split('\n\n');
            for (let i = 0; i < paragraphs.length; i++) {
                const para = paragraphs[i].trim();
                if (!para) continue;
                const $p = $('<p></p>');
                const lines = para.split('\n');
                for (let j = 0; j < lines.length; j++) {
                    if (j > 0) $p.append($('<br>'));
                    $p.append(document.createTextNode(lines[j]));
                }
                $content.append($p);
            }

            let footerText = 'Generated: ' + data.generated_at;
            if (data.is_cached) footerText += ' (cached)';
            $content.append($('<p class="text-muted guardian-summary-footer"></p>').text(footerText));

            $actions.show();
            $localeToggle.val(locale);
        }

        function renderError(message) {
            $content.empty().append($('<p class="text-danger"></p>').text(message));
        }
    };

    return postlogin;
}(Postlogin || {}));
